// @ts-nocheck: converted from JS

import Attachments from '@/components/Studies/Attachments';

export default Attachments;
